var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.001 0C3.582 0 0 3.582 0 7.999C0 11.276 1.97 14.09 4.789 15.327C4.765 14.768 4.784 14.098 4.927 13.491C5.082 12.841 5.957 9.131 5.957 9.131C5.957 9.131 5.702 8.62 5.702 7.865C5.702 6.679 6.389 5.794 7.244 5.794C7.973 5.794 8.323 6.341 8.323 6.995C8.323 7.726 7.857 8.821 7.618 9.834C7.417 10.683 8.043 11.375 8.879 11.375C10.396 11.375 11.417 9.428 11.417 7.122C11.417 5.369 10.236 4.056 8.088 4.056C5.661 4.056 4.15 5.866 4.15 7.887C4.15 8.584 4.354 9.076 4.677 9.456C4.824 9.631 4.845 9.702 4.791 9.902C4.753 10.049 4.665 10.404 4.628 10.544C4.575 10.747 4.411 10.819 4.228 10.745C3.11 10.288 2.59 9.065 2.59 7.688C2.59 5.416 4.507 2.691 8.307 2.691C11.362 2.691 13.373 4.901 13.373 7.273C13.373 10.412 11.627 12.757 9.055 12.757C8.191 12.757 7.379 12.289 7.101 11.759C7.101 11.759 6.636 13.603 6.538 13.958C6.368 14.574 6.036 15.192 5.733 15.672C6.469 15.89 7.233 16 8.001 16C12.419 16 16 12.418 16 7.999C16 3.582 12.419 0 8.001 0Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.43cc5ff10493e62b5cbea94fc8d38fba.svg";
export { ForwardRef as ReactComponent };